import React, { FC, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton, Chip, Tooltip } from '@mui/material';

import { AppViews } from 'endpoints';
import logoImgBR from 'images/logos/gipsyy-original-logo.png';
import logoImg from 'images/logos/Logo-Gipsyy-and-Royal.png';
import { GipsyInstanceType } from 'global';

import { IStore } from 'store/reducers';

import { LoggedUserResponse } from 'store/types/users';

import { logoutAgency, loggedInUser } from 'store/actions';
import styles from './Header.module.css';
import { LogoutAgency, BoxNames, NameAgency, NameBox } from './Header.styles';

import LanguageSelect from './LanguageSelect';
import UserMenu from './UserMenu';

interface Props {
  handleShowSidebar: () => void;
}

const Header: FC<Props> = ({ handleShowSidebar }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { location } = useHistory();
  const history = useHistory();
  const [current, setCurrent] = useState<LoggedUserResponse>();
  const [loading, setLoading] = useState(false);

  const { token }: any = useSelector<IStore>((state) => state.authAgency);
  const isTokenAgency = !!token;
  const getLoggedUser = async () => {
    setLoading(true);
    const res: LoggedUserResponse = await dispatch(loggedInUser.request());
    setCurrent(res);
    setLoading(false);
    localStorage.setItem('agencyName', res?.agencyCommercialName);
    localStorage.setItem('userName', res?.name);
  };

  useEffect(() => {
    if (location.pathname !== '/agency/auth') {
      getLoggedUser();
    }
  }, []);

  const logoutUserAgency = () => {
    dispatch(logoutAgency());
    history.push(AppViews.AGENCY_LOGIN, 'checkout-pass');
  };

  return (
    <div className="container">
      <div className={styles.mainMenu}>
        <div className={styles.leftSection}>
          <button id="btnMenu" onClick={handleShowSidebar} type="button">
            <span />
            <span />
            <span />
          </button>
        </div>

        <span className={styles.centerSection}>
          <a
            onClick={() => {
              history.push({ pathname: AppViews.HOME, state: 'no-access-checkout' });
            }}
          >
            {process.env.REACT_APP_INSTANCE_TYPE === GipsyInstanceType.BRAZIL && (
              <img src={logoImgBR} alt="Gipsyy logo" className={styles.logo} />
            )}
            {process.env.REACT_APP_INSTANCE_TYPE === GipsyInstanceType.PORTUGAL && (
              <img src={logoImg} alt="Gipsyy logo" className={styles.logo} />
            )}
          </a>
        </span>

        {!isTokenAgency ? (
          <span className={styles.rightSection}>
            <LanguageSelect />
            <UserMenu />
          </span>
        ) : (
          <span className={styles.rightSection}>
            <span className={styles.help}>
              <BoxNames>
                {loading ? (
                  <Skeleton width="50px" />
                ) : (
                  <>
                    <Tooltip title={current?.name || ''} arrow placement="top" followCursor>
                      <NameBox>
                        Olá,&nbsp; <b>{current?.name}</b>
                      </NameBox>
                    </Tooltip>

                    <Tooltip title={current?.agencyCommercialName || ''} arrow placement="top" followCursor>
                      <NameAgency>{current?.agencyCommercialName}</NameAgency>
                    </Tooltip>
                  </>
                )}
              </BoxNames>
              <LogoutAgency onClick={() => logoutUserAgency()}>Sair</LogoutAgency>
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

export default Header;
